export default __webpack_public_path__ + "static/media/ic_filter_collapse.1905bc4a.svg";